function addProductToCart(quantity, productId) {
    
    const inputElement = document.querySelector('.cart-notification__text');
    const inputSubElement = document.querySelector('.cart-notification__sub-text');
    const imageElement = document.getElementById('cart-notification__image');
    const estShippingElement = document.querySelector('.estimated-shipping');

    let formData = {
        'items': [{
            'id': productId,
            'quantity': quantity
         }]
       };

       fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status == 422) {

            inputElement.innerText = data.message.replace('Cart', 'Basket');
            inputSubElement.innerText = data.description.replace('cart', 'basket');
            imageElement.remove();


        } else {

            estShippingElement.style.display = 'block'; 
            
            if (quantity > 1 ) {
                const notificationMessage = quantity + " items added to your basket";
                inputElement.innerText = notificationMessage
            } else {
                const notificationMessage = quantity + " item added to your basket";
                inputElement.innerText = notificationMessage
            }

        
        const price = data.items[0].price / 100;
        const notificationText = data.items[0].vendor + '<br><strong>' + data.items[0].title + '</strong><br>£' + price;
        inputSubElement.innerHTML = notificationText
        }

        const img_src = data.items[0].featured_image.url
        
        imageElement.innerHTML = "<img src=" + img_src + "/>"

       
        
      })
      .catch((error) => {
        console.error('Error:', error);
        
      });

}

// add to cart on button click
const submitButton = document.querySelector('.product-form__submit');
let cartNotification = document.querySelector('.cart-notification-wrapper');

submitButton.addEventListener('click', (e) => {
    e.preventDefault();

    const quantityInput = document.querySelector('.quantity__input')
    const itemId = quantityInput.getAttribute('data-quantity-variant-id');
    const quantity = parseInt(quantityInput.value);

    if (!isNaN(quantity)) {
        addProductToCart(quantity, itemId); 
    }
    
    cartNotification.style.display = 'block';

});


// close the pop-up on button click
const closeButton = document.querySelector('.cart-notification__close');
const closeCross = document.querySelector('.cart-notification__cross');

closeButton.addEventListener('click', (e) => {
    cartNotification.style.display = 'none';
});

closeCross.addEventListener('click', (e) => {
    cartNotification.style.display = 'none';
});

cartNotification.addEventListener('click', (e) => {
    if (e.target !== cartNotification) {
        return;
    }
    cartNotification.style.display = 'none';
});




